export default "__VITE_ASSET__a3812d3a__"